export default __webpack_public_path__ + "static/media/hht2_ep07_timeline_q04_b.980777d4.png";